import Reveal from "./Reveal";
import { MapPin, Star } from "lucide-react";
import { Link } from "react-router-dom";

const STATES = [
  "Alabama", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Idaho", "Illinois", "Indiana",
  "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
  "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
  "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
  "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming",
];

const HOME_STATE = "Florida";

export default function StatesCovered() {
  return (
    <section id="coverage" className="py-20 sm:py-24 lg:py-32 bg-[#F7F5F0]" data-testid="states-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="max-w-3xl mb-12 sm:mb-14">
            <p className="text-sm sm:text-base font-bold uppercase tracking-[0.18em] text-[#FF008F] mb-4">Nationwide Coverage</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] leading-tight">
              Serving all 48 contiguous states.
            </h2>
            <p className="mt-4 text-[#475569] leading-relaxed">
              We monitor county and court records across the continental United States. No matter where your foreclosure happened, if surplus funds exist, we can help you recover them.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {STATES.map((state) => {
              const isHome = state === HOME_STATE;
              return (
                <Link
                  key={state}
                  to={`/blog?state=${encodeURIComponent(state)}`}
                  className={`group relative flex items-center gap-2 rounded-xl px-3 py-2.5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 ${
                    isHome
                      ? "bg-gradient-to-br from-[#FF008F]/8 to-white border-2 border-[#FF008F] ring-2 ring-[#FF008F]/10"
                      : "bg-white border border-[#E2DDD3] hover:border-[#FF008F]"
                  }`}
                  data-testid={`state-${state.toLowerCase().replace(/\s+/g, "-")}`}
                  aria-label={isHome ? `${state} — Home base — see articles` : `${state} — see articles`}
                >
                  {isHome ? (
                    <Star className="w-3.5 h-3.5 fill-[#FF008F] text-[#FF008F] shrink-0" />
                  ) : (
                    <MapPin className="w-3.5 h-3.5 text-[#1E3A8A] group-hover:text-[#FF008F] shrink-0 transition-colors" />
                  )}
                  <span className={`text-sm truncate ${isHome ? "font-bold text-[#0F172A]" : "text-[#0F172A]"}`}>
                    {state}
                  </span>
                  {isHome && (
                    <span
                      className="ml-auto shrink-0 text-[9px] font-bold uppercase tracking-wider text-white bg-[#FF008F] rounded-full px-2 py-0.5"
                      data-testid="state-florida-badge"
                    >
                      Home
                    </span>
                  )}
                </Link>
              );
            })}
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 grid sm:grid-cols-3 gap-4">
            <Highlight value="48" label="States covered" />
            <Highlight value="3,100+" label="County jurisdictions" />
            <Highlight value="24-hr" label="Initial response time" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

function Highlight({ value, label }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E2DDD3] p-5 shadow-sm">
      <p className="font-serif-display font-bold text-3xl sm:text-4xl text-[#FF008F]">{value}</p>
      <p className="text-xs uppercase tracking-wider text-[#64748B] mt-1">{label}</p>
    </div>
  );
}
